import { Box, Stack, Tag, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import type { UserDetails } from '../../types'
import { WORLD_LEVEL_TO_UI_DETAILS } from './constants'
import { getAugmentedLevelTitle, getAugmentedWorldLevel } from './internal/helpers'
import type { AugmentedWorldLevel } from './types'

export default function LevelFlair({
  user,
  worldSlug,
  level,
}: {
  user?: Pick<UserDetails, 'id' | 'roles'>
  worldSlug?: string
  level?: AugmentedWorldLevel | null
}): JSX.Element | null {
  const augmentedLevel: AugmentedWorldLevel | null = getAugmentedWorldLevel({
    user,
    level: level ?? null,
  })

  if (augmentedLevel == null) {
    return null
  }
  const { icon, tagBgColor, tagTextColor } = WORLD_LEVEL_TO_UI_DETAILS[augmentedLevel]

  return (
    <Box>
      <Tag bg={tagBgColor} color={tagTextColor}>
        <Stack direction="row" align="center" spacing="4px" fontSize="12px">
          <FontAwesomeIcon icon={icon} />
          <Text fontWeight="bold" fontSize="12px" color={tagTextColor} whiteSpace="nowrap">
            {getAugmentedLevelTitle({ worldSlug, augmentedLevel })}
          </Text>
        </Stack>
      </Tag>
    </Box>
  )
}
